import { Box, Skeleton } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { ConnectWallet, useConnectionStatus } from '@thirdweb-dev/react';
import React, { useState } from 'react';
import { useMedia } from 'react-use';

import { ConnectWalletWelcomeScreen } from '@app/components/AppHeader/components/ConnectWalletWelcomeScreen';
import { ConnectedWallet } from '@app/components/ConnectedWallet';

import s from './Account.module.scss';
import { useReferenceElement } from '@app/hooks/other/useReferenceElement';

const MobileWalletBtn = styled.div`
  background: var(--brand-black);
  border: 1px solid var(--brand-white);
  border-radius: 50%;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px !important;
  padding: 8px !important;

  &:hover {
    color: var(--brand-orange);
  }
`;

export const Account = () => {
  const connectionStatus = useConnectionStatus();
  const isMobile = useMedia('(max-width: 960px)', true);
  const { referenceElement, setReferenceElement } = useReferenceElement();

  function renderContent() {
    if (connectionStatus === 'connecting' || connectionStatus === 'unknown') {
      return <Skeleton width="146px" height="44px" />;
    }

    if (connectionStatus === 'connected') {
      return (
        <Box ref={setReferenceElement}>
          <ConnectedWallet referenceElement={referenceElement} />
        </Box>
      );
    }

    return (
      <ConnectWallet
        className={s.connectBtn}
        switchToActiveChain
        theme="dark"
        modalSize="wide"
        welcomeScreen={() => {
          return <ConnectWalletWelcomeScreen />;
        }}
        detailsBtn={
          isMobile ? () => <MobileWalletBtn>M</MobileWalletBtn> : undefined
        }
      />
    );
  }

  return <Box ml="auto">{renderContent()}</Box>;
};
